import React from 'react';
import { Col, ListGroupItem, Row } from 'reactstrap';

export const PushNotificationNotify = ({ data, type, message, onClientRedirect, index, removeNotificationAndClose }) => {

    const onNotificationClick = (e) => {
        e.preventDefault();
        onClientRedirect(data.contractId, index, data, type);
    }  

    const onCloseHanlder = (e) => {
        e.preventDefault();
        removeNotificationAndClose(index, true);
    }

    return <ListGroupItem key={index}
        className="list-group-item-action">
        {data.contractId !== '00000000-0000-0000-0000-000000000000' &&
            <Row className="align-items-center">
                <Col md="11" className="pr-1">
                    <a className="list-group-item-action" href="#item" onClick={e => onNotificationClick(e, data)}>
                        <p className="text-sm mb-0">
                            {data.clientId &&
                                <span>Client ID <span className="h5">{data.clientId}</span>: </span>
                            }
                            <span>{message}</span> &nbsp; Please click here to view the exception...</p>
                    </a>

                </Col>
                <Col md="1" className="pl-0">
                    <a href="#delelte" onClick={e => onCloseHanlder(e)}>
                        <i className="ni ni-fat-remove"></i>
                    </a>
                </Col>
            </Row>
        }
    </ListGroupItem>;
};